module.exports = __webpack_public_path__ + "../resources/images/DragInMail-0a12a5c06cbb9c43de0695d14973f210.gif";